import { render } from "./VolumeUp.vue?vue&type=template&id=fc146d48"
const script = {}
script.render = render

export default script